module.exports = __webpack_public_path__ + "static/media/pearl-drums-3.d17146d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/DrumsPage/assets/pearl-drums-3.png
// module id = 394
// module chunks = 0